module.exports = __webpack_public_path__ + "img/techsoup_together_logo_orange.3162842f.png";